import { DataTypes, DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
  import { Site } from "../external-sources/Sites";
  import { SchemaContext } from "../../common";
import { Modes } from "./mode";
import { User } from "../external-sources/Users";
import { LinkedInstance } from "../external-sources/LinkedInstances";

export const createSiteName = (context: SchemaContext): FieldSchema => ({
  name: "siteName",
  grid: {
    displayed: true,
    order: 4,
    defaultVisible: true,
  },
  dataTransform: {
    fromGraphql: {
      getter: ({ siteName }) => {
        if (siteName) {
          return context.sites.find((s) => s.siteName === siteName);
        }
        return siteName;
      },
    },
    toGraphql: {
      getter: ({ siteName }) => {
        if (siteName) {
          return (siteName as Site).siteName ?? EMPTY_VALUE;
        }
        return siteName;
      },
    },
    toDb: {
      getter: ({ siteName }) => {
        if (siteName) {
          return (siteName as Site).siteName ?? EMPTY_VALUE;
        }
        return siteName;
      },
    },
  },
  data: {
    type: DataTypes.OBJECT,
    variant: DataVariants.ENUM,
    options: context.sites.map((site) => ({ value: site, label: site.siteName })),
    assignedValue: {
      getter: ({ currentUser, mode, siteName }) => {
        if (
          currentUser &&
          siteName === undefined &&
          [Modes.CREATE].includes(mode as Modes)
        ) {
          return context.sites.find(
            (site) => site.siteName === (currentUser as User).site
          ) || EMPTY_VALUE;
        }
        return siteName;
      },
      fields: ["currentUser", "mode", "siteName"],
    },
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: {
    label: "Site", type: InputTypes.SELECT,
    disabled: {
      getter: ({ linkedInstance, mode, currentUser }) => {
        return (
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["linkedInstance", "mode", "currentUser"],
    },
  },
});

export default createSiteName;
